let publicResizeTo, WW, WH, DH, ST, previousTop = 0, d = false, lastScrollTop, scrolldown = 0;


$(document).ready(function () {
    publicButton();
    publicModal();
    publicMenu();
    publicSearch();
    publicGridRowLineWidth();

    closeNotification();

    if ($('.page__article').length) {
        publicArticle();
    }

    if ($('.page__search').length) {
        publicPageSearchList()
    }

    if ($('.wi-tooltip').length) {
        writerTooltip();
    }

    if ($('.block__slider-parent').length) {
        blockSlider();
    }

    if ($('[data-fancybox]').length || $('.page__article-ctn img').length) {
        publicGallery();
    }

    if ($('.readpost__comment').length) {
        readpostComment();
        createPlaceholder();
    }

    SShare = new SocialShare();

    publicResize();
    $(window).resize(function () {
        clearTimeout(publicResizeTo);
        publicResizeTo = setTimeout(function () {
            publicResize();
        }, 400);
    });

    publicScroll();
    $(window).scroll(function () {
        publicScroll();
    });

    setTimeout(function () {
        $('html').addClass('page-loaded');
        publicPageContrast();
    }, 300);
});

function publicPageSearchList() {
    let headerHeight = $('.header').outerHeight();
    let footerHeight = $('.footer').outerHeight();
    let documentHeight = $(window).height();
    console.log(documentHeight);
    $('.page__search').css('min-height', documentHeight - (headerHeight + footerHeight) + 80);
}

function publicArticle() {
    let elementContrastChecks = [
        {bg: 'body', read: '.preview-date div', write: '.preview-date div', prop: 'color', cssVar: '--page-article-color'},
        /*  {bg: 'body', read: '.preview-content-header .preview-title', write: '.preview-content-header .preview-title', prop: 'color'},
            {bg: 'body', read: '.preview-authors svg', write: '.preview-authors svg', prop: 'fill'},
            {bg: 'body', read: '.preview-content-header .preview-short', write: '.page__article', prop: 'fill', debug: true},
            {bg: 'body', read: '.preview-date div', write: '.preview-date div', prop: 'color'},
            {bg: 'body', read: '.preview-date svg', write: '.preview-date svg', prop: 'fill'},
            {bg: 'body', read: '.preview-tags svg', write: '.preview-tags svg', prop: 'fill'},
            {bg: 'body', read: '.preview-categories svg', write: '.preview-categories svg', prop: 'fill'},
            {bg: 'body', read: '.page__article-ctn p', write: '.page__article-ctn p', prop: 'color'},
            {bg: 'body', read: '.readpost-action-item span', write: '.readpost-action-item span', prop: 'color'},
            {bg: 'body', read: '.readpost-action-item svg', write: '.readpost-action-item svg', prop: 'fill'},
            {bg: 'body', read: '.more__articles h2', write: '.more__articles h2', prop: 'color'},
            {bg: 'body', read: '.item svg', write: '.item svg', prop: 'fill'},
            {bg: 'body', read: '.item .item__time-name', write: '.item .item__time-name', prop: 'color'},
            {bg: 'body', read: '.readpost__comment-text p', write: '.readpost__comment-text p', prop: 'color'},
            {bg: 'body', read: '.readpost__comment-text', write: '.readpost__comment-text', prop: 'border-color'},
            {bg: 'body', read: '.readpost__comment-name', write: '.readpost__comment-name', prop: 'color'},
            {bg: 'body', read: '.readpost__comment-name span', write: '.readpost__comment-name span', prop: 'color'},
            {bg: 'body', read: '.readpost__comments-item span p', write: '.readpost__comments-item span p', prop: 'color'},
            {bg: 'body', read: '.readpost__comments-item span p', write: '.page__article', prop: 'color', cssVar: '--comment-color'}*/
    ];

    let altColorApplied = false;

    elementContrastChecks.forEach(({bg, read, write, prop, delay, cssVar, debug}) => {
        let runCheck = function () {
            let $bg = $(bg);
            let $read = $(read);
            if (!$bg.length || !$read.length) {
                if (debug) console.log('[contrast]', read, 'kihagyva – bg:', $bg.length, 'read:', $read.length);
                return;
            }

            let bgColor = rgbToHex($bg.css('background-color'));
            let current = rgbToHex($read.css(prop));


            let {ratio, isAA} = getContrastRatio(bgColor, current, 2);
            let value = isAA ? '#212121' : '#ffffff';

            if (debug) console.log('[contrast]', read, {bgColor: bgColor, current: current, ratio: ratio, isAA: isAA, value: value});

            if (value !== '#ffffff') {
                if (debug) console.log('[contrast]', read, 'kihagyva – nem fehér az eredmény');
                return;
            }

            if (cssVar) {
                $(write).each(function () {
                    this.style.setProperty(cssVar, value);
                });

                if (!altColorApplied) {
                    altColorApplied = true;
                    $('.page__article').css({
                        '--page-article-color-alt': '#E1E1E1',
                        '--page-article-color': '#ffffff'
                    });
                }
            } else {
                $(write).css(prop, value);
            }
        };

        if (delay) {
            setTimeout(runCheck, parseInt(delay, 10));
        } else {
            runCheck();
        }
    });
}

function publicArticleHeader() {
    let contentImage = $('.preview-image img');
    if (!contentImage.length) {
        return;
    }

    if (!contentImage.get(0).complete) {
        contentImage.one('load error', function () {
            publicArticleHeader();
        });
        return;
    }

    contentImage.css({'height': '', 'object-fit': ''});

    let windowHeight = $(window).height();
    let headerHeight = $('header').outerHeight();
    let contentHeader = $('.preview-content-header').outerHeight();

    if (windowHeight < (headerHeight + contentHeader)) {
        let overflow = (headerHeight + contentHeader) - windowHeight;
        let imageHeight = Math.max(contentImage.outerHeight() - overflow, 120);

        contentImage.css({
            'max-height': imageHeight + 'px',
            'object-fit': 'cover'
        });
    }
}

function publicMenu() {
    function updateMenuWidth() {
        let $ctn = $('.pw__nav-menu-ctn');

        if (!$ctn.length) {
            return;
        }

        let ctn = $ctn[0];
        let overflows = (ctn.scrollWidth - ctn.clientWidth) > 1;

        $('.pw__nav-menu').toggleClass('sys', overflows);

        updateScrollButtons();
    }

    function updateHeaderHeight() {
        let root = document.documentElement;
        let height = Math.ceil($('header').outerHeight() || 0);

        if (height <= 0) {
            return;
        }

        if (root.style.getPropertyValue('--menu-height') !== height + 'px') {
            root.style.setProperty('--menu-height', height + 'px');
        }
    }

    function refreshMenu() {
        updateHeaderHeight();
        updateMenuWidth();
    }

    refreshMenu();
    $(window).on('resize', refreshMenu);
    $(window).on('load', refreshMenu);

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
        document.fonts.ready.then(refreshMenu);
    }

    if (typeof ResizeObserver !== 'undefined' && $('header').length) {
        new ResizeObserver(refreshMenu).observe($('header')[0]);
    }

    $('.pw__nav-menu').css('opacity', 1);

    $(document).on('click', '.pw__nav-submenu-toggler', function (e) {
        e.stopPropagation();
        $(this).siblings('.pw__nav-submenu').toggleClass('active');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.pw__nav-submenu, .pw__nav-submenu-toggler').length) {
            $('.pw__nav-submenu').removeClass('active');
        }
    });

    let scrollInterval = null;
    let scrollStep = 5;


    function updateScrollButtons() {
        let $ctn = $('.pw__nav-menu-ctn');
        if (!$ctn.length) return;

        let scrollLeft = $ctn.scrollLeft();
        let maxScroll = $ctn[0].scrollWidth - $ctn[0].clientWidth;

        let leftHidden = scrollLeft <= 0;
        let rightHidden = scrollLeft >= maxScroll - 1;
        $('.pw__nav-menu-button-left').css({opacity: leftHidden ? 0 : 1, visibility: leftHidden ? 'hidden' : 'visible'});
        $('.pw__nav-menu-button-right').css({opacity: rightHidden ? 0 : 1, visibility: rightHidden ? 'hidden' : 'visible'});
    }

    function startScroll(direction) {
        let $ctn = $('.pw__nav-menu-ctn');
        stopScroll();
        scrollInterval = setInterval(function () {
            $ctn.scrollLeft($ctn.scrollLeft() + (direction * scrollStep));
            updateScrollButtons();
        }, 16);
    }

    function stopScroll() {
        if (scrollInterval) {
            clearInterval(scrollInterval);
            scrollInterval = null;
        }
    }

    updateScrollButtons();
    $('.pw__nav-menu-ctn').on('scroll', updateScrollButtons);

    $(document).on('mousedown touchstart', '.pw__nav-menu-button-right', function (e) {
        e.preventDefault();
        startScroll(1);
    });

    $(document).on('mousedown touchstart', '.pw__nav-menu-button-left', function (e) {
        e.preventDefault();
        startScroll(-1);
    });

    $(document).on('mouseup mouseleave touchend touchcancel', '.pw__nav-menu-button-right, .pw__nav-menu-button-left', function () {
        stopScroll();
    });

    $(document).on('mouseup touchend', function () {
        stopScroll();
    });
}

function publicButton() {
    $('.pw__button-anim').mousemove(function (e) {

        var x = e.pageX - $(e.currentTarget).offset().left,
            y = e.pageY - $(e.currentTarget).offset().top;

        $(e.currentTarget).find('span.bg').css({
            'left': x,
            'top': y
        });
    });
}

function getContrastRatio(fgColor, bgColor, value) {
    function getLuminance(color) {
        let rgb = tinycolor(color).toRgb();
        let r = rgb.r / 255;
        let g = rgb.g / 255;
        let b = rgb.b / 255;
        r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
        g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
        b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }

    let fgLuminance = getLuminance(fgColor);
    let bgLuminance = getLuminance(bgColor);
    let lighter = Math.max(fgLuminance, bgLuminance);
    let darker = Math.min(fgLuminance, bgLuminance);
    let ratio = (lighter + 0.05) / (darker + 0.05);

    let limit = parseFloat(value);
    if (isNaN(limit)) {
        limit = 3.99;
    }

    return {
        ratio: ratio,
        isAA: ratio >= limit,
        isAAA: ratio >= 7
    };
}

function rgbToHex(rgb) {
    let parts = rgb && rgb.match(/\d+/g);
    if (!parts) return null;
    return '#' + parts.map(x => parseInt(x).toString(16).padStart(2, '0')).join('');
}

function publicPageContrast() {
    let elementContrastChecks = [
        {bg: '.pw__button-user', read: '.pw__button-user .text', write: '.pw__button-user .text', prop: 'color'},
        {bg: '.block__slider .item__category', read: '.block__slider .item__category', write: '.block__slider .item__category', prop: 'color'},
        {bg: '.block__highlight .item__category', read: '.block__highlight .item__category', write: '.block__highlight .item__category', prop: 'color'},
        {bg: '.block__row .item__category', read: '.block__row .item__category', write: '.block__row .item__category', prop: 'color'},
        {bg: '.preview-locked', read: '.preview-locked p', write: '.preview-locked p', prop: 'color'},
        {bg: '.preview-locked', read: '.preview-locked svg', write: '.preview-locked svg', prop: 'fill'},
        {bg: '.preview-locked', read: '.preview-locked p a', write: '.preview-locked p a', prop: 'color', delay: 1000},
        {bg: '.preview-locked', read: '.preview-locked .pw__button', write: '.preview-locked .pw__button', prop: 'background-color'},
        {bg: '.preview-locked .pw__button', read: '.preview-locked .pw__button .text', write: '.preview-locked .pw__button .text', prop: 'color'},
        {bg: '.pw__background', read: '.pw__button-contrast .item__subscription-title', write: '.pw__button-contrast .item__subscription-title', prop: 'color'},
        {bg: '.pw__background', read: '.pw__button-contrast .item__subscription-text', write: '.pw__button-contrast .item__subscription-text', prop: 'color'},
        {bg: '.pw__background', read: '.pw__button-contrast', write: '.pw__button-contrast', prop: 'background-color'},
        {bg: '.pw__background .pw__button-contrast', read: '.pw__background .text', write: '.pw__background .text', prop: 'color'},
        {bg: '.more__articles .item__category', read: '.more__articles .item__category', write: '.more__articles .item__category', prop: 'color'},
        {bg: '.pw__nav-menu-wrapper', read: '.pw__nav-menu-list a', write: '.pw__nav-menu-ctn', prop: 'color', cssVar: '--menu-after-color'},
        {bg: '.pw__nav-menu-wrapper', read: '.pw__nav-menu-list a', write: '.pw__nav-menu-list a', prop: 'color'},
        {bg: '.pw__nav-menu-wrapper', read: '.pw__nav-menu-button  svg', write: '.pw__nav-menu-button  svg', prop: 'fill'},
        {bg: '.footer__bottom', read: '.footer__bottom-center p', write: '.footer__bottom-center p', prop: 'color', cssVar: '--footer-divider-color'},
        {bg: '.footer__bottom', read: '.footer__bottom p', write: '.footer__bottom p', prop: 'color'},
        {bg: '.footer__bottom', read: '.footer__bottom a', write: '.footer__bottom a', prop: 'color'},
        {bg: '.footer__bottom', read: '.footer__bottom svg', write: '.footer__bottom svg', prop: 'fill'},
        {bg: '.footer__top', read: '.footer__social-menu svg', write: '.footer__social-menu svg', prop: 'fill'},
        {bg: '.footer__top', read: '.footer__top p', write: '.footer__top p', prop: 'color'},
        {bg: '.footer__top', read: '.footer__top a', write: '.footer__top a', prop: 'color'},
        {bg: '.item__subscription-box .pw__button', read: '.item__subscription-box .pw__button', write: '.item__subscription-box .pw__button .text', prop: 'color'},
        {bg: '.item__subscription-box', read: '.item__subscription-box .item__subscription-title', write: '.item__subscription-box .item__subscription-title', prop: 'color'},
        {bg: '.item__subscription-box', read: '.item__subscription-box .item__subscription-text', write: '.item__subscription-box .item__subscription-text', prop: 'color'},
        {bg: '.item__subscription-box', read: '.item__subscription-box .item__subscription-text-mini', write: '.item__subscription-box .item__subscription-text-mini', prop: 'color'},
        {bg: '.item__subscription-box', read: '.item__subscription-box .item__subscription-text-mini a', write: '.item__subscription-box .item__subscription-text-mini a', prop: 'color'},
        {bg: '.block__highlight .item', read: '.block__highlight .item .item__link', write: '.block__highlight .item .item__link', prop: 'color'},
        {bg: '.block__highlight .item', read: '.block__highlight .item .item__text', write: '.block__highlight .item .item__text', prop: 'color'}
    ];


    elementContrastChecks.forEach(({bg, read, write, prop, delay, cssVar, debug}) => {
        let runCheck = function () {
            let $bg = $(bg);
            let $read = $(read);
            if (!$bg.length || !$read.length) {
                if (debug) console.log('[contrast]', read, 'kihagyva – bg:', $bg.length, 'read:', $read.length);
                return;
            }


            let bgColor = rgbToHex($bg.css('background-color'));
            let current = rgbToHex($read.css(prop));


            let {ratio, isAA} = getContrastRatio(bgColor, current);
            let value = isAA ? '#212121' : '#ffffff';

            if (debug) console.log('[contrast]', read, {bgColor: bgColor, current: current, ratio: ratio, isAA: isAA, value: value});

            if (cssVar) {
                $(write).each(function () {
                    this.style.setProperty(cssVar, value);
                });
            } else {
                $(write).css(prop, value);
            }
        };

        if (delay) {
            setTimeout(runCheck, parseInt(delay, 10));
        } else {
            runCheck();
        }
    });


    let contrastChecks = [
        {bg: 'body', read: '.pw__nav li a', write: '.pw__nav li a, .text__color', prop: 'color'},
        {bg: 'body', read: '.pw__nav li a', write: '.pw__nav li a, .text__color', prop: 'data-color'},
        {bg: 'body', read: '.pw__nav-menu-button svg', write: '.pw__nav-menu-button svg', prop: 'fill'},
        {bg: 'body', read: '.pw__nav-menu-button svg', write: '.pw__nav-menu-button svg', prop: 'fill'}
    ];

    contrastChecks.forEach(({bg, read, write, prop}) => {
        let $bg = $(bg);
        let $read = $(read);
        if (!$bg.length || !$read.length) return;

        let isData = prop.indexOf('data-') === 0;

        let bgColor = rgbToHex($bg.css('background-color'));
        let current = rgbToHex(isData ? $read.attr(prop) : $read.css(prop));
        let {ratio, isAA} = getContrastRatio(bgColor, current);

        let value = isAA ? '#212121' : '#ffffff';
        if (isData) {
            $(write).attr(prop, value);
        } else {
            $(write).css(prop, value);
        }
    });
}

function publicGridRowLineWidth() {
    let target = $('.item__line span');
    target.each(function (i, v) {
        let width = $(v).parents('.item').find('.item__maintitle').width();
        $(v).width(width);
    });
}

function publicDonationSlider() {
    $('.fanpage-donations').each(function () {
        let el = $(this);
        el.removeClass('no-slider');

        if (el.find('.fanpage__box').length > 2) {
            let slickOptions = {
                infinite: false,
                draggable: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                speed: 400,
                centerMode: false,
                initialSlide: 0,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            infinite: true,
                            slidesToShow: 1.2,
                            draggable: true
                        }
                    }
                ]
            }

            slickOptions.responsive.push({
                breakpoint: 576,
                settings: 'unslick'
            });

            $(this).on('init', function () {
                setTimeout(function () {
                    resizePublicBoxes('.fanpage__box-content-top');
                    resizePublicBoxes('.fanpage__box-content-top .fanpage__box-title');
                }, 100);
            }).slick(slickOptions);
        } else {
            el.addClass('no-slider');
        }
    });
}

let fanpageCollapsedHeight = 107;

function initFanpageDescription() {
    let boxes = $('.fanpage__box').find('.fanpage__box-inner');
    let descriptions = $('.fanpage__box').find('.fanpage__box-description');

    boxes.css({'min-height': '', 'height': ''});
    descriptions.find('.show-more, .show-less').remove();
    descriptions.removeClass('hys sys').css('height', '');

    descriptions.each(function (i, v) {
        let el = $(v);
        let moreText = el.data('more');
        let lessText = el.data('less');

        if (el.height() >= fanpageCollapsedHeight) {
            el.addClass('hys');
            el.append('<button class="fanpage__box-button show-more">' + moreText + '</button>');
            el.append('<button class="fanpage__box-button show-less hys">' + lessText + '</button>');

            el.height(fanpageCollapsedHeight);
        }
    });

    setTimeout(function () {
        let maxHeight = 0;
        boxes.each(function () {
            let h = $(this).outerHeight();
            if (h > maxHeight) maxHeight = h;
        });
        boxes.css({'min-height': maxHeight, 'height': 'auto'});
    }, 150);

    $(document).on('click', '.fanpage__box-description .show-more', function () {
        let el = $(this);
        let parent = el.parent();
        let currentHeight = parent.height();
        let autoHeight = parent.css('height', 'auto').height();

        parent.height(currentHeight).animate({height: autoHeight + 30}, 400);
        parent.addClass('sys');
        el.hide();
        setTimeout(function () {
            parent.find('.show-less').fadeIn();
        }, 300);
    });

    $(document).on('click', '.fanpage__box-description .show-less', function () {
        let el = $(this);
        let parent = el.parent();

        parent.animate({height: fanpageCollapsedHeight}, 400);
        parent.removeClass('sys');
        el.hide();
        setTimeout(function () {
            parent.find('.show-more').fadeIn();
        }, 300);
    });
}

function publicFanpageMobil() {

    function getLuminance(r, g, b) {
        const toLinear = (channel) => {
            const c = channel / 255;
            return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        };

        const R = toLinear(r);
        const G = toLinear(g);
        const B = toLinear(b);

        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }

    function getContrastRatio(rgb1, rgb2) {
        const lum1 = getLuminance(...rgb1);
        const lum2 = getLuminance(...rgb2);
        const lighter = Math.max(lum1, lum2);
        const darker = Math.min(lum1, lum2);
        return ((lighter + 0.05) / (darker + 0.05));
    }

    function adjustWhiteForContrast(bgRgb, minRatio = 3.0) {
        let value = 255;

        while (value > 0) {
            const white = [value, value, value];
            const contrast = getContrastRatio(bgRgb, white);
            if (contrast >= minRatio) {
                return white;
            }
            value -= 5;
        }

        return [0, 0, 0];
    }

    function getDominantColor(imgElement) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = imgElement.naturalWidth;
        canvas.height = imgElement.naturalHeight;

        ctx.drawImage(imgElement, 0, 0);

        let imageData;
        try {
            imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        } catch (e) {
            // Más domainről (CORS fejléc nélkül) betöltött képnél a canvas "tainted",
            // a pixelek nem olvashatók – ilyenkor nincs dominant color.
            return null;
        }
        const pixels = imageData.data;

        const colorCount = {};

        for (let i = 0; i < pixels.length; i += 4) {
            const r = pixels[i];
            const g = pixels[i + 1];
            const b = pixels[i + 2];
            const a = pixels[i + 3];

            if (a < 128) continue;

            const color = `${r},${g},${b}`;
            colorCount[color] = (colorCount[color] || 0) + 1;
        }

        const isWhiteish = ([r, g, b]) => r > 240 && g > 240 && b > 240;
        const isBlackish = ([r, g, b]) => r < 15 && g < 15 && b < 15;

        const filteredColors = Object.entries(colorCount).filter(([color]) => {
            const [r, g, b] = color.split(',').map(Number);
            return !isWhiteish([r, g, b]) && !isBlackish([r, g, b]);
        });

        const sortedColors = (filteredColors.length > 0 ? filteredColors : Object.entries(colorCount))
            .sort((a, b) => b[1] - a[1]);

        if (!sortedColors.length) return null;

        let [r, g, b] = sortedColors[0][0].split(',').map(Number);

        const lighten = (v) => Math.round(v + (255 - v) * 0.2);
        r = lighten(r);
        g = lighten(g);
        b = lighten(b);

        return [r, g, b];
    }

    function isCrossOriginUrl(src) {
        try {
            return new URL(src, window.location.href).origin !== window.location.origin;
        } catch (e) {
            return false;
        }
    }

    function analyzeImages() {
        const images = document.querySelectorAll('.fanpage__box-cover');

        const showSlider = () => {
            const sliderCtn = document.querySelector('.fanpage-donations-slider-nomobil');
            if (sliderCtn) sliderCtn.style.display = 'block';
        };

        images.forEach(img => {
            const applyColor = (source) => {
                const sampleImg = source || img;
                if (!sampleImg.naturalWidth || !sampleImg.naturalHeight) return;

                const rgb = getDominantColor(sampleImg);
                if (!rgb) {
                    // Nem tudtuk kiolvasni a képet: marad az alap háttér/szövegszín.
                    showSlider();
                    return;
                }
                const bgColor = `rgb(${rgb.join(',')})`;

                const contrastWithWhite = getContrastRatio(rgb, [255, 255, 255]);
                let textColor = 'rgb(255,255,255)';

                const parent = img.closest('.fanpage__box-inner');
                if (parent) {
                    parent.style.backgroundColor = bgColor;

                    if (contrastWithWhite < 3.0) {
                        const adjustedWhite = adjustWhiteForContrast(rgb, 3);
                        textColor = `rgb(${adjustedWhite.join(',')})`;
                        const title = parent.querySelector('.fanpage__box-title');
                        const amount = parent.querySelector('.fanpage__box-amount');
                        const monthly = parent.querySelector('.fanpage__box-amount > .fanpage__box-monthly');
                        const description = parent.querySelector('.fanpage__box-description');
                        const svgElement = parent.querySelector('.fanpage__box-toggler > .fanpage__box-toggler-svg');

                        if (title) title.style.color = textColor;
                        if (amount) amount.style.color = textColor;
                        if (monthly) monthly.style.color = textColor;
                        if (description) description.style.color = textColor;
                        if (svgElement) svgElement.style.fill = textColor;

                    }
                }
                showSlider();
            };

            const start = () => {
                const src = img.currentSrc || img.src;

                if (!src || !isCrossOriginUrl(src)) {
                    applyColor(img);
                    return;
                }

                // Idegen domainről jövő kép: CORS-os másolatot töltünk, hogy a canvas
                // olvasható legyen. Ha a kiszolgáló nem ad CORS fejlécet, csak a
                // színezés marad el, hibát nem dobunk.
                const corsImg = new Image();
                corsImg.crossOrigin = 'anonymous';
                corsImg.onload = () => applyColor(corsImg);
                corsImg.onerror = () => showSlider();
                corsImg.src = src;
            };

            if (img.complete) {
                start();
            } else {
                img.addEventListener('load', start);
            }
        });
    }

    analyzeImages();

    setTimeout(function () {
        $('.fanpage__box-v2').each(function (i, v) {
            $(v).find('.fanpage-description').removeClass('hys-mobil');
            $(v).find('.show-more-mobil').remove();
            $(v).find('.show-less-mobil').remove();

        });
    }, 400);

    $(document).off('click', '.fanpage__box-toggler').on('click', '.fanpage__box-toggler', function () {
        const $toggler = $(this);
        const $inner = $toggler.closest('.fanpage__box-inner');
        const $description = $inner.find('.fanpage__box-description');

        if (!$toggler.hasClass('active')) {
            $toggler.addClass('active');
            $description.stop(true, true).slideDown();
        } else {
            $description.stop(true, true).slideUp();
            $toggler.removeClass('active');
        }
    });
}

function publicModal() {
    function openModal(modalId, dev) {
        let modal = $('#' + modalId);
        if (modal.length) {
            $('.pw__modal.active').not(modal).each(function () {
                closeModal($(this));
            });

            modal.addClass('active');
            $('body').addClass('overflow-hidden');

            if (dev == 1) {
                publicDonationSlider();
                initFanpageDescription();
            }
        }
    }

    function closeModal(modal) {
        modal.removeClass('active');
        $('body').removeClass('overflow-hidden');

        modal.find('.fanpage-donations.slick-initialized').slick('unslick');
    }

    $(document).on('click', '[data-modal-trigger]', function (e) {
        e.preventDefault();
        let modalId = $(this).data('modal-trigger');
        let dev = $(this).data('dev');
        openModal(modalId, dev);
    });

    $(document).on('click', '[data-modal-close]', function () {
        let modal = $(this).closest('.pw__modal');
        closeModal(modal);
    });

    $(document).on('click', '.pw__modal', function (e) {
        if ($(e.target).hasClass('pw__modal') || $(e.target).hasClass('pw__modal-dialog')) {
            closeModal($(this));
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            let modal = $('.pw__modal.active');
            if (modal.length) {
                closeModal(modal);
            }
        }
    });
}

function publicSearch() {
    $('.js-show-search').on('click', function () {
        $('.pw__nav-search-bar').addClass('sys');
        $('.pw__nav-search-bar input').trigger('focus');
    });

    $(document).on('click', '.pw__nav-search-bar', function (e) {
        let $target = $(e.target);
        if ($target.closest('.js-close-search').length || !$target.closest('form').length) {
            $(this).removeClass('sys');
        }
    });
}

function blockSlider() {
    $('.block__slider-parent').each(function () {
        let el = $(this);

        if (el.find('.item').length >= 2) {
            el.on('init', function () {
                let bgColor = el.find('.slick-next').css('background-color');
                let contrastWithBlack = getContrastRatio('#212121', bgColor);
                if (contrastWithBlack.isAA) {

                } else {
                    el.find('.slick-arrow').addClass('light');

                }
            }).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            });
        }
    });
}

function publicGallery() {
    document.querySelectorAll('.writer__post-content img').forEach(function (img) {
        if (!img.closest('[data-fancybox]')) {
            img.setAttribute('data-fancybox', 'cikk-gallery');
        }
    });

    Fancybox.bind('[data-fancybox]', {
        Toolbar: {
            display: {
                left: ['infobar'],
                middle: [],
                right: ['close']
            }
        },
        Thumbs: {
            type: 'classic',
            showOnStart: true
        },
        on: {
            ready: function () {
                function applyContrast(selector) {
                    let $bg = $(selector);
                    let $read = $bg.find('svg');
                    if (!$bg.length || !$read.length) return false;

                    let bgColor = rgbToHex($bg.css('background-color'));
                    let current = rgbToHex($read.css('stroke'));
                    if (!bgColor || !current) return false;

                    let {isAA} = getContrastRatio(bgColor, current);
                    if (!isAA) {
                        $bg.addClass('light');
                    }
                    return true;
                }

                let attempts = 0;
                (function waitForButtons() {
                    let okMain = applyContrast('.fancybox__nav .f-button');
                    let okRight = applyContrast('.fancybox__toolbar__column.is-right .f-button');


                    if (okMain && okRight) {
                        fButtonContrastDone = true;
                        return;
                    }

                    if (++attempts < 60) {
                        requestAnimationFrame(waitForButtons);
                    }
                })();
            }
        }
    });
}

function inlineColorOf($source) {
    return ($source && $source.length) ? ($source[0].style.color || '') : '';
}

function emptyParagraph($source) {
    let color = inlineColorOf($source);
    return color ? '<p style="color: ' + color + '"><br></p>' : '<p><br></p>';
}

function readpostComment() {
    $(".readpost__comment-text").on("focus", function () {
        let self = $(this);

        self.parents('.readpost__comment').addClass('on-focus');

        let placeholder = self.find("p.placeholder");
        if (placeholder.length > 0) {
            let newHtml = emptyParagraph(placeholder);
            placeholder.remove();

            self.html(newHtml);

            let range = document.createRange();
            let sel = window.getSelection();
            let newParagraph = self.find("p")[0];
            range.setStart(newParagraph, 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (self.text().trim() === "") {
            self.html(emptyParagraph(self.find("p").first()));

            let range = document.createRange();
            let sel = window.getSelection();
            let newParagraph = self.find("p")[0];
            range.setStart(newParagraph, 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }).on("keydown", function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();

            let newParagraph = $("<p>&nbsp;<br>&nbsp;</p>");
            $(this).find("p").last().after(newParagraph);

            let range = document.createRange();
            let sel = window.getSelection();
            range.setStart(newParagraph[0], 0);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }

    }).on("keyup", function (e) {
        if (e.keyCode === 8 || e.keyCode === 46) {
            let self = $(this);

            if (self.text().trim() === "" && self.find("p").length === 0) {
                self.html("<p><br></p>");

                let range = document.createRange();
                let sel = window.getSelection();
                let newParagraph = self.find("p")[0];
                range.setStart(newParagraph, 0);
                range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    }).on("paste", function (e) {
        e.preventDefault();

        let self = $(this);
        let clipboardData = e.originalEvent.clipboardData || window.clipboardData;
        let pastedText = clipboardData.getData('text/plain');

        if (pastedText) {
            let cleanText = pastedText.replace(/\n/g, ' ').replace(/\r/g, ' ');

            let selection = window.getSelection();
            if (selection.rangeCount > 0) {
                let range = selection.getRangeAt(0);
                range.deleteContents();
                let textNode = document.createTextNode(cleanText);
                range.insertNode(textNode);

                range.setStartAfter(textNode);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.readpost__comment').length) {
            $('.readpost__comment').each(function () {
                var $wrap = $(this),
                    clone = $wrap.find('.readpost__comment-text').clone();

                clone.find('p.placeholder').remove();

                if (clone.text().trim() === '') {
                    $wrap.removeClass('on-focus');
                }
            });
            createPlaceholder();
        }
    });

    // A hozzászólás-ikon ugyanarra a szekcióra görget, mint az értesítő e-mail
    // „Hozzászólok" gombja — közös implementáció: WP.scrollToComments().
    // (Korábban az animate() egy FÜGGVÉNYT kapott property-objektum helyett, így
    // semmi nem történt; a levont $('.navbar') pedig nem is létezik a portálon.)
    $('.js-write-comment').on('click', function () {
        // Vendégnél az ikon login-modalt nyit (data-modal-trigger) — ott nem görgetünk,
        // a nyitott layer alatt amúgy sincs értelme.
        if (this.hasAttribute('data-modal-trigger')) return;
        if (window.WP && WP.scrollToComments) { WP.scrollToComments(); }
    });
}

function createPlaceholder() {
    let $ctn = $(".readpost__comment-text");
    let placeholder = $ctn.data('placeholder');

    if ($ctn.text().trim() === "") {
        if ($ctn.find("p.placeholder").length === 0) {
            let color = inlineColorOf($ctn.find("p").first()) || inlineColorOf($ctn);
            let style = color ? ' style="color: ' + color + '"' : '';

            $ctn.html('<p class="placeholder"' + style + '>' + placeholder + '</p>');
        }
    }
}

function writerTooltip() {
    document.querySelectorAll('.tooltip-box').forEach(el => el.remove());

    const tooltips = document.querySelectorAll('.wi-tooltip');

    tooltips.forEach(tooltip => {
        const text = tooltip.getAttribute('data-text');
        const position = tooltip.getAttribute('data-position') || 'top-center';

        const tooltipBox = document.createElement('div');
        tooltipBox.className = 'tooltip-box';
        tooltipBox.setAttribute('data-position', position);

        tooltipBox.innerHTML = text;

        tooltip.appendChild(tooltipBox);

        const rect = tooltipBox.getBoundingClientRect();

        if (rect.left < 0) {
            tooltipBox.classList.add('overflow-left');
        } else if (rect.right > window.innerWidth) {
            tooltipBox.classList.add('overflow-right');
        }
    });
}

function publicResize() {
    WW = $(window).width();
    WH = $(window).height();
    DH = $(document).height();

    if (WW <= 575) {
        if ($('.fanpage-donations').length) {
            publicFanpageMobil();
        }
    } else {
        $('.fanpage-donations .fanpage__box-inner').removeAttr('style');
    }
}

function publicScroll() {
    WW = $(window).width();
    ST = $(window).scrollTop();
    let cat = $('.pw__nav').outerHeight();

    if (ST < previousTop) {
        /*Fel*/
        if (ST > 0) {
            /*Nem tető*/
            $('html').addClass('show-nav');
            $('.header').css('transform', 'translateY(' + cat + 'px)');
        } else {
            /*Tető*/
            $('html').removeClass('show-nav scrolled-down');
            $('.header').removeAttr('style');
        }
    } else {
        /*Le*/

        if (ST > previousTop && ST > cat && !d) {
            $('html').addClass('scrolled-down');
            $('.header').removeAttr('style').css('top', cat * -1);
            $('html').removeClass('show-nav');
            lastScrollTop = ST;

            if (scrolldown == 0) {
                setTimeout(function () {
                    $(window).scrollTop($(window).scrollTop() + 1);
                    scrolldown = 1;
                }, 100);
            }
        }

    }

    previousTop = ST;

    $('.parallaxbg').each(function () {
        var top = $(this).offset().top;
        var h = $(this).outerHeight(true);
        if ((top - WH) < ST && (top + h) > ST) {
            $(this).css('background-position', 'center ' + ((ST - top) * 0.3) + 'px');
        }
    });
}

function createNotification(text, source) {
    let title = $('#custom_donation_error_title').val();
    $('body').append('<div class="notification notification-dismiss notification-success">' + '<img src="../public/img/icons/close-border.svg" class="notification-close" width="34" height="34" alt="" title=""/>' + '<div><p>' + title + '</p><span>' + text + '</span></div>' + '</div>');

    setTimeout(function () {
        $('.notification').addClass('sys');
    }, 100);
    setTimeout(function () {
        $(source).removeClass('disable');
    }, 4000);
    setTimeout(function () {
        $('.notification').remove();
    }, 15000);

}

function closeNotification() {
    $(document).on('click', '.notification-close', function () {
        $('.notification-dismiss').addClass('hys');

        setTimeout(function () {
            $('.notification-dismiss').remove();
        }, 3000);
    });
}

var SShare = null

function SocialShare() {
    var self = this

    this.shareUrls = {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=[URL]',
        twitter: 'https://twitter.com/intent/tweet?text=[TITLE]+[URL]',
        email: 'mailto:?subject=[TITLE]&body=[URL]',
        gplus: 'https://plus.google.com/share?url=[URL]',
        tumblr:
            'https://www.tumblr.com/widgets/share/tool?canonicalUrl=[URL]&title=[TITLE]', //&caption={desc}
    }

    this.init = function () {
        if (!$('.js-socialShare').length) {
            return
        }

        this.bindClickOnShare()
    }

    this.bindClickOnShare = function () {
        $(document)
            .off('click.socialShare', '.js-socialShare')
            .on('click.socialShare', '.js-socialShare', function (e) {
                e.preventDefault()
                e.stopImmediatePropagation()
                self.fireShare($(this))
            })
    }

    this.isSharing = false
    this.shareWindow = null

    this.fireShare = function ($button) {
        if (this.isSharing) {
            return
        }
        this.isSharing = true
        setTimeout(function () {
            self.isSharing = false
        }, 1000)

        var type = $button.data('type')
        var url = this.shareUrls[type]

        var parentD = $button.parents('.social-data')
        if (parentD.length) {
            var title = parentD.data('title')
            var surl = parentD.data('url')
        } else {
            var title = $('title').html()
            var surl = $button.data('url')
        }

        url = url.replace('[TITLE]', encodeURIComponent(title))
        url = url.replace('[URL]', encodeURIComponent(surl))

        if (type === 'email') {
            window.location.href = url
        } else {
            this.shareWindow = window.open(
                url,
                'wiSocialShare',
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
            )

            if (this.shareWindow) {
                this.shareWindow.focus()
            }
        }
    }
    this.init()
}


function createModal(title, text, button) {
    $('#generalModal').remove();

    $('body').append('<div class="pw__modal" id="generalModal">' +
        '<div class="pw__modal-dialog pw__modal-dialog-xl">' +
        '<div class="pw__modal-content">' +
        '<button type="button" class="pw__modal-close" data-modal-close>' +
        '<img src="../public/img/icons/close.svg" width="34" height="34" alt=""/>' +
        '</button>' +
        '<h2 class="pw__modal-title text__center">' + title + '</h2>' +
        '<p>' + text + '</p>' +
        '<div class="pw__modal-actions justify-content-center">' +
        '<button type="button" class="pw__button pw__button-turq-border pw__button-lg pw__button-anim text__highlight text__uppercase" data-modal-close>' +
        '<span class="bg"></span>' +
        '<span class="text text__contrast">' + button + '</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>');

    $('#generalModal').addClass('active');
    $('body').addClass('overflow-hidden');
}

function resizePublicBoxes(boxes) {
    if ($.type(boxes) === 'string') boxes = $(boxes);

    let h = 0;
    boxes.height('auto');
    boxes.each(function () {
        if ($(this).height() > h) h = $(this).height();
    });


    if (boxes.hasClass('form-reg')) {
        boxes.height(h + 40);
    } else {
        boxes.height(h);
    }

}